<script setup lang="ts">
// types
import type { SectionBannerTextBlockProps } from '@ts-sections/section-banner-text-block/interfaces'
// hooks
import { useSectionBannerTextBlock } from '@hooks/sections/section-banner-text-block.hook'
// components
import { SectionLayout } from '@UI/Layouts/SectionLayout'
import BlockBannerTextBlock from '@Blocks/BlockBannerTextBlock.vue'

defineOptions({
  name: 'SectionBannerTextBlock',
})

const props = defineProps<{
  section: SectionBannerTextBlockProps
}>()

const {
  refTitle,
  refDescription,
  refBackgroundColor,
} = useSectionBannerTextBlock({
  section: () => props.section,
})
</script>

<template>
  <SectionLayout
    class="section-banner-text-block"
    :data-component="section.__component"
    :title="refTitle"
    :title-tag="section.layout?.titleTag"
    :description="refDescription"
    :color="refBackgroundColor"
    :space="section.layout?.space"
  >
    <BlockBannerTextBlock
      v-if="section.banner"
      class="section-banner-text-block__banner"
      :block="section.banner"
    />
  </SectionLayout>
</template>

<style scoped lang="scss" src="@scss/components/Sections/SectionBannerTextBlock.scss" />
